import type { FC } from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components/macro';

import { useResponsive } from 'contexts/ResponsiveContext';

const TicketsCardViewLoader: FC = () => {
  const theme = useTheme();
  const { isMobile, isTablet, isDesktop, isLargeDesktop } = useResponsive();

  return (
    <ContentLoader
      data-testid="tickets-cards-loading"
      speed={2}
      width="100%"
      height="100vh"
      backgroundColor={theme.colors.surface}
      foregroundColor={theme.colors.primary.variant6}
    >
      {isMobile && (
        <>
          <rect x="0" y="0" rx="6" ry="6" width="100%" height="64" />
          <rect x="0" y="76" rx="6" ry="6" width="100%" height="64" />
          <rect x="0" y="152" rx="6" ry="6" width="100%" height="64" />
          <rect x="0" y="228" rx="6" ry="6" width="100%" height="64" />
          <rect x="0" y="304" rx="6" ry="6" width="100%" height="64" />
          <rect x="0" y="380" rx="6" ry="6" width="100%" height="64" />
          <rect x="0" y="456" rx="6" ry="6" width="100%" height="64" />
          <rect x="0" y="532" rx="6" ry="6" width="100%" height="64" />
          <rect x="0" y="608" rx="6" ry="6" width="100%" height="64" />
          <rect x="0" y="684" rx="6" ry="6" width="100%" height="64" />
          <rect x="0" y="760" rx="6" ry="6" width="100%" height="64" />
        </>
      )}

      {(isTablet || isDesktop) && (
        <>
          <rect x="0" y="0" rx="6" ry="6" width="49%" height="132" />
          <rect x="51%" y="0" rx="6" ry="6" width="49%" height="132" />

          <rect x="0" y="144" rx="6" ry="6" width="49%" height="132" />
          <rect x="51%" y="144" rx="6" ry="6" width="49%" height="132" />

          <rect x="0" y="288" rx="6" ry="6" width="49%" height="132" />
          <rect x="51%" y="288" rx="6" ry="6" width="49%" height="132" />

          <rect x="0" y="432" rx="6" ry="6" width="49%" height="132" />
          <rect x="51%" y="432" rx="6" ry="6" width="49%" height="132" />

          <rect x="0" y="576" rx="6" ry="6" width="49%" height="132" />
          <rect x="51%" y="576" rx="6" ry="6" width="49%" height="132" />

          <rect x="0" y="720" rx="6" ry="6" width="49%" height="132" />
          <rect x="51%" y="720" rx="6" ry="6" width="49%" height="132" />
        </>
      )}

      {isLargeDesktop && (
        <>
          <rect x="0" y="0" rx="6" ry="6" width="32%" height="132" />
          <rect x="34%" y="0" rx="6" ry="6" width="32%" height="132" />
          <rect x="68%" y="0" rx="6" ry="6" width="32%" height="132" />

          <rect x="0" y="144" rx="6" ry="6" width="32%" height="132" />
          <rect x="34%" y="144" rx="6" ry="6" width="32%" height="132" />
          <rect x="68%" y="144" rx="6" ry="6" width="32%" height="132" />

          <rect x="0" y="288" rx="6" ry="6" width="32%" height="132" />
          <rect x="34%" y="288" rx="6" ry="6" width="32%" height="132" />
          <rect x="68%" y="288" rx="6" ry="6" width="32%" height="132" />

          <rect x="0" y="432" rx="6" ry="6" width="32%" height="132" />
          <rect x="34%" y="432" rx="6" ry="6" width="32%" height="132" />
          <rect x="68%" y="432" rx="6" ry="6" width="32%" height="132" />

          <rect x="0" y="576" rx="6" ry="6" width="32%" height="132" />
          <rect x="34%" y="576" rx="6" ry="6" width="32%" height="132" />
          <rect x="68%" y="576" rx="6" ry="6" width="32%" height="132" />

          <rect x="0" y="720" rx="6" ry="6" width="32%" height="132" />
          <rect x="34%" y="720" rx="6" ry="6" width="32%" height="132" />
          <rect x="68%" y="720" rx="6" ry="6" width="32%" height="132" />
        </>
      )}
    </ContentLoader>
  );
};

export default TicketsCardViewLoader;
